/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Carousel_PreviousInputs */

const id_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide sebelumnya`)
};

const ms_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slaid sebelumnya`)
};

const da_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige slide`)
};

const de_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Folie`)
};

const en_us2_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const es_es2_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva anterior`)
};

const es_mx2_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva anterior`)
};

const fil_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakaraang slide`)
};

const fr_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositive précédente`)
};

const it_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide precedente`)
};

const hu_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előző dia`)
};

const nl_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorige dia`)
};

const no_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige lysbilde`)
};

const pl_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzedni slajd`)
};

const pt_br2_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const pt_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide anterior`)
};

const ro_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide anterior`)
};

const fi_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edellinen dia`)
};

const sv_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föregående bild`)
};

const vi_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang trình chiếu trước`)
};

const tr_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki slayt`)
};

const cs_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí snímek`)
};

const bg_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишен слайд`)
};

const ru_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий слайд`)
};

const uk_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попередній слайд`)
};

const ar_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشريحة السابقة`)
};

const hi_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली स्लाइड`)
};

const th_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สไลด์ก่อนหน้า`)
};

const ja_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のスライド`)
};

const zh_cn2_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const zh_hant1_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const ko_ui_carousel_previous = /** @type {(inputs: Ui_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

/**
* | output |
* | --- |
* | "Previous slide" |
*
* @param {Ui_Carousel_PreviousInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const ui_carousel_previous = /** @type {((inputs?: Ui_Carousel_PreviousInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Carousel_PreviousInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ui_carousel_previous(inputs)
	if (locale === "ms") return ms_ui_carousel_previous(inputs)
	if (locale === "da") return da_ui_carousel_previous(inputs)
	if (locale === "de") return de_ui_carousel_previous(inputs)
	if (locale === "en-US") return en_us2_ui_carousel_previous(inputs)
	if (locale === "es-ES") return es_es2_ui_carousel_previous(inputs)
	if (locale === "es-MX") return es_mx2_ui_carousel_previous(inputs)
	if (locale === "fil") return fil_ui_carousel_previous(inputs)
	if (locale === "fr") return fr_ui_carousel_previous(inputs)
	if (locale === "it") return it_ui_carousel_previous(inputs)
	if (locale === "hu") return hu_ui_carousel_previous(inputs)
	if (locale === "nl") return nl_ui_carousel_previous(inputs)
	if (locale === "no") return no_ui_carousel_previous(inputs)
	if (locale === "pl") return pl_ui_carousel_previous(inputs)
	if (locale === "pt-BR") return pt_br2_ui_carousel_previous(inputs)
	if (locale === "pt") return pt_ui_carousel_previous(inputs)
	if (locale === "ro") return ro_ui_carousel_previous(inputs)
	if (locale === "fi") return fi_ui_carousel_previous(inputs)
	if (locale === "sv") return sv_ui_carousel_previous(inputs)
	if (locale === "vi") return vi_ui_carousel_previous(inputs)
	if (locale === "tr") return tr_ui_carousel_previous(inputs)
	if (locale === "cs") return cs_ui_carousel_previous(inputs)
	if (locale === "bg") return bg_ui_carousel_previous(inputs)
	if (locale === "ru") return ru_ui_carousel_previous(inputs)
	if (locale === "uk") return uk_ui_carousel_previous(inputs)
	if (locale === "ar") return ar_ui_carousel_previous(inputs)
	if (locale === "hi") return hi_ui_carousel_previous(inputs)
	if (locale === "th") return th_ui_carousel_previous(inputs)
	if (locale === "ja") return ja_ui_carousel_previous(inputs)
	if (locale === "zh-CN") return zh_cn2_ui_carousel_previous(inputs)
	if (locale === "zh-Hant") return zh_hant1_ui_carousel_previous(inputs)
	return ko_ui_carousel_previous(inputs)
});
export { ui_carousel_previous as "ui.carousel.previous" }